import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

// Thunk for getting home banners
const apiRequest = async (apiFn, api, errorMessage, data) => {
    try {
        const response = await apiFn(api, data);
        if (response?.success) {
            return response?.data;
        } else {
            throw new Error(response?.message || errorMessage);
        }
    } catch (error) {
        throw new Error(error.message || errorMessage);
    }
};
export const getNotifications = createAsyncThunk(
    'header/notifications',
    async (_, { rejectWithValue }) => {
        try {
            const notifications = await apiRequest(
                GET,
                API.GET_NOTIFICATIONS,
                "User Notifications fetch failed"
            );
            return notifications;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const NotificationStatus = createAsyncThunk(
    'header/NotificationStatus',
    async (id, { rejectWithValue }) => {
        console.log(id, 'header/NotificationStatus');

        try {
            const response = await POST(API.NOTIFICATION_STATUS + `/${id}`);
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


// Create the slice
const notificationSlice = createSlice({
    name: "notification",
    initialState: {
        notifications: [],
        error: null,
        status: 'idle',
        location: null,  // Store geolocation data
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getNotifications.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getNotifications.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.notifications = action.payload;  // Store the geolocation coordinates
            })
            .addCase(getNotifications.rejected, (state, action) => {
                state.status = 'failed';
                state.locationError = action.payload;  // Store the location error
            });
    },
});

export default notificationSlice.reducer;